export * from './lib/get-cookie-domain';
